<template>
  <div id="body" class="body">
    <div class="header flex aic">
      <img
        class="flex"
        style="width: 20%"
        src="https://qishimai-1257428522.file.myqcloud.com/website/new/logo.png"
      />
      <div class="title flex">七十迈旅行</div>
      <div class="flex">
        <a href="tel:4008-270-170">
          <img
            style="width: 24px; height: 25px"
            src="https://qishimai-1257428522.file.myqcloud.com/website/new/mobile/websitephone_navbtn_phone.png"
        /></a>
      </div>
    </div>
    <div class="banner">
      <swiper
        id="banner"
        :options="swiperOption"
        class="swiper-wrap banner-swiper"
        ref="mySwiper"
      >
        <swiper-slide v-for="(item, index) in homeData.mbanner" :key="index">
          <div class="banner-wrap">
            <a :href="item.url" target="_blank">
              <img
                class="cp"
                style="width: 100vw; height: 49vw"
                :src="item.img"
              />
            </a>
          </div>
        </swiper-slide>
        <!-- 常见的小圆点 -->
        <div
          class="swiper-pagination banner-swiper-pagination"
          v-for="(item, index) in homeData.banner"
          :key="index"
          slot="pagination"
        ></div>
      </swiper>
    </div>
    <div class="about box-flex-center">
      <div class="title">我们的故事</div>
      <div class="describe" style="margin-bottom: 25px">
        {{ homeData.about.text }}
      </div>
      <!-- <a :href="homeData.about.url" target="_blank">
        <div class="button" style="margin: 20px 0">更多关于我们</div>
      </a> -->
      <video
        style="width: 100%; height: 100%"
        :src="homeData.about.video"
        poster="https://qishimai-1257428522.file.myqcloud.com/website/new/mobile/websitephone_img_videocover.jpg"
        controls="controls"
      ></video>
    </div>
    <div class="book box-flex-center">
      <div class="title">智能路书</div>
      <div class="describe" style="margin-bottom: 10px">
        {{ homeData.roadbook.text }}
      </div>
      <div class="book-list">
        <div
          v-for="(item, index) in homeData.roadbook.booklist"
          v-if="index < 6"
          :key="index"
        >
          <div class="roadbook-box" @click="goApplet(item.uuid)">
            <img class="roadbook-image" :src="item.image" alt="" />
            <div class="roadbook-info">
              <div class="flex jcsb">
                <div class="ellipsis fs14 fw500">{{ item.name }}</div>
                <div class="red-color fs12">
                  ¥<span class="fs14 fw500">{{ item.price }}</span>
                </div>
              </div>
              <div class="gray-color fs12 ellipsis">{{ item.subname }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="trip box-flex-center">
      <div class="title" style="color: #ffffff">定制旅行</div>
      <div class="describe" style="color: #ffffff">
        {{ homeData.customize.text }}
      </div>
      <div
        class="button"
        style="margin: 20px 0"
        @click="goCustomize('/customizeMobile')"
      >
        了解更多定制
      </div>
      <div class="customize-box">
        <div class="black-color fs18 tac fw600" style="margin-bottom: 15px">
          免费定制行程
        </div>
        <div class="flex aic">
          <div class="fs14 fw500 black-color fw600">目的地</div>
          <div class="customize-input-wrap">
            <input placeholder="请填写目的地" type="text" v-model="place" />
          </div>
        </div>
        <div class="flex aic">
          <div class="fs14 fw500 black-color fw600">手机号</div>
          <div class="customize-input-wrap">
            <input
              placeholder="请填写手机号"
              type="number"
              v-model="phoneNumber"
            />
          </div>
        </div>
        <div class="flex aic">
          <div class="fs14 fw500 black-color fw600">验证码</div>
          <div class="flex jcsb aic customize-input-wrap">
            <input
              style="width: 120px"
              placeholder="请填写验证码"
              type="number"
              v-model="authCode"
            />
            <div class="main-color fs12 cp" @click="sendLoginAuthCode">
              {{
                authCodeCountDown > 0 ? `${authCodeCountDown}s` : "获取验证码"
              }}
            </div>
          </div>
        </div>
        <button class="customize-button cp" @click="customizeSubmit">
          获取免费专属行程
        </button>
      </div>
    </div>
    <div class="team box-flex-center">
      <div class="title">跟团自驾</div>
      <div class="describe">{{ homeData.grouptour.text }}</div>
      <div class="flex grouptour-city">
        <div
          class="cp"
          :class="
            index === groupCityIndex
              ? 'fs14 grouptour-city-item fw600'
              : 'fs14 grouptour-city-item'
          "
          :style="
            index === groupCityIndex ? 'color: #0BA09A' : 'color: #333333'
          "
          v-for="(item, index) in homeData.grouptour.citys"
          :key="index"
          @click="() => (groupCityIndex = index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="flex fww jcsb">
        <div
          class="grouptour-box"
          v-for="(item, index) in homeData.grouptour.citys[groupCityIndex]
            .routelist"
          :key="index"
        >
          <a :href="item.url" target="_blank">
            <img class="grouptour-box-img" :src="item.image"
          /></a>
          <div class="fs13 fw500 black-color" style="padding: 0 10px">
            <div style="height: 30px">{{ item.name }}</div>
            <div class="flex jcsb aic" style="padding: 10px 0">
              <div class="red-color fw500">
                ¥<span class="fs16">{{ item.price }}</span
                >/起
              </div>
              <div class="main-color cp">
                <a
                  class="main-color"
                  href="https://work.weixin.qq.com/kfid/kfc6d1ecd63d5c00552"
                  >咨询客服</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="evaluate box-flex-center">
      <div class="title">用户评价</div>
      <div class="describe" style="margin-bottom: 10px">
        {{ homeData.evaluate.text }}
      </div>
      <div
        v-for="(item, index) in homeData.evaluate.commentlist"
        v-if="index < 3"
        :key="index"
      >
        <div class="evaluate-box">
          <div class="flex aic" style="margin-bottom: 10px">
            <img class="evaluate-avatar" :src="item.useravatar" alt="" />
            <div class="fs13 fw500" style="color: #0ba09a">
              {{ item.username }}
            </div>
          </div>
          <div class="flex aic main-color fs12" style="margin-bottom: 4px">
            <img
              style="width: 10px; margin-right: 4px"
              src="https://qishimai-1257428522.file.myqcloud.com/website/new/comment_time.png"
              alt=""
            />
            <div>{{ item.date }}·出行</div>
          </div>
          <div class="gray-color fs12 ellipsis3" style="margin-bottom: 14px">
            {{ item.content }}
          </div>
          <img
            class="evaluate-image cp"
            v-for="(item, index) in item.images"
            :key="index"
            :src="item.minImg"
            @click="imgOnPreviewUrl = item.bigImg"
          />
        </div>
      </div>
    </div>
    <div class="story box-flex-center">
      <div class="title">旅行故事</div>
      <div class="describe" style="margin-bottom: 10px">
        {{ homeData.travelstory.text }}
      </div>
      <div class="flex fww">
        <div
          class="travelstory-box"
          v-for="(item, index) in homeData.travelstory.storylist"
          :key="index"
          v-if="index < 2"
        >
          <img class="travelstory-box-img" :src="item.image" />
          <div class="flex jcsb aic pd2" style="margin: 4px 0 0 0">
            <div class="flex aic">
              <!-- <div class="travelstory-tag">真人讲解</div> -->
              <div class="fs12 gray-color">主播：{{ item.author }}</div>
            </div>
            <div class="flex aic travelstory-play cp" @click="audioPlay(index)">
              <img
                v-if="index === audioOnPlayIndex && isPlay"
                src="https://qishimai-1257428522.file.myqcloud.com/website/static/pause_icon.png"
                style="width: 8px; height: 10px; margin-right: 2px"
              />
              <img
                v-else
                src="https://qishimai-1257428522.file.myqcloud.com/website/static/play_icon.png"
                style="width: 8px; height: 10px; margin-right: 2px"
              />
              <div>
                {{ index === audioOnPlayIndex && isPlay ? "暂停" : "播放" }}
              </div>
              <audio :id="`audio${index}`" v-if="index === audioOnPlayIndex">
                <source :src="item.audio" type="audio/mpeg" />
              </audio>
            </div>
          </div>
          <div
            class="fs14 fw500 ellipsis2 black-color pd2"
            style="padding: 6px 5px"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="box-flex-center footer">
      <div class="bgcolor">
        <div class="flex fxdc aic" style="padding: 0 3vw">
          <div class="title">关于我们</div>
          <div class="subtitle">ABOUT US</div>
          <div class="flex fww jcsb aic">
            <a
              v-for="(item, index) in commonData.friendlylink"
              :key="index"
              :href="item.url"
              target="_blank"
            >
              <img class="friendlylink-image" :src="item.image" alt="" />
            </a>
          </div>
          <div class="flex tac fs12 jcsb">
            <div class="code-wrap">
              <img
                class="code-image"
                src="https://qishimai-1257428522.file.myqcloud.com/website/new/QR_code/miniprogram_code.png"
                alt=""
              />
              <div>七十迈旅行<br />小程序</div>
            </div>
            <div class="code-wrap">
              <img
                class="code-image"
                style="border-radius: 8px"
                src="https://qishimai-1257428522.file.myqcloud.com/website/other/qishimaiguojizijia.png"
                alt=""
              />
              <div>七十迈国际自驾<br />公众号</div>
            </div>
            <div class="code-wrap">
              <img
                class="code-image"
                src="https://qishimai-1257428522.file.myqcloud.com/website/new/QR_code/officialaccount_code.png"
                alt=""
              />
              <div>七十迈旅行<br />公众号</div>
            </div>
          </div>
        </div>
        <div class="bgcolor2">
          <div class="flex fxdc aic jcsa copyright-wrap fs10">
            <div class="line-hight">
              Copyright © 2014 七十迈旅行. 保留所有权利
            </div>
            <div class="line-hight">
              备案号：<a
                class="white-color"
                href="https://beian.miit.gov.cn/"
                target="_blank"
                >京ICP备15033671号-3</a
              >
            </div>
            <div class="line-hight">电话：4008-270-170</div>
            <div class="line-hight">
              地址：北京市朝阳区南磨房路37号华腾北搪商务大厦516室
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="imgOnPreviewUrl"
      class="modal-mask"
      @click="imgOnPreviewUrl = undefined"
    >
      <div class="image-preview-box" style="width: 80vw">
        <!-- <img class='image-preview-box-close' style="height: 20px;width:20px;padding: 10px;" src="../assets/close_icon.png" @click="imgOnPreviewUrl = undefined"> -->
        <img :src="imgOnPreviewUrl" />
      </div>
    </div>
    <div v-if="showSuccessModal" class="modal-mask">
      <div class="modal-box">
        <img
          src="https://qishimai-1257428522.file.myqcloud.com/website/new/customerservice_avatar.png"
          class="modal-avatar"
        />
        <div class="modal-title" style="margin-top: 50px">提交成功</div>
        <div class="modal-content" style="margin-top: 6px">
          我们已收到您的需求
        </div>
        <div class="modal-content">
          旅行顾问将在<span style="color: #0ba09a">24小时之内联系您</span>
        </div>
        <div class="modal-content" style="margin-bottom: 16px">
          请保持电话畅通
        </div>
        <div class="modal-btn cp" @click="showSuccessModal = false">好的</div>
      </div>
    </div>
    <div v-if="showToast" class="toast">
      <div>{{ toastContent }}</div>
    </div>
    <img
      @click="goPage('https://work.weixin.qq.com/kfid/kfc6d1ecd63d5c00552')"
      class="online-service"
      src="https://qishimai-1257428522.file.myqcloud.com/website/new/mobile/websitephone_popbtn_customerservice.png"
      alt=""
    />
  </div>
</template>

<script>
import homeData from "@/utils/staticData/homeData";
import { get, post } from "@/utils/config.http";
import { api } from "@/utils/constVar";
import commonData from "@/utils/staticData/commonData";

export default {
  name: "Mobile",
  components: {},
  data() {
    return {
      commonData,
      homeData,
      groupCityIndex: 0,
      phoneNumber: "",
      authCode: "",
      place: "",
      authCodeCountDown: 0,
      showSuccessModal: false,
      showToast: false,
      toastContent: "",
      imgOnPreviewUrl: undefined,
      audioOnPlayIndex: undefined,
      isPlay: false,
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        //循环
        loop: true,
        //设定初始化时slide的索引
        initialSlide: 0,
        //自动播放
        autoplay: 2000,
        autoplayStopOnLast: false,
        paginationClickable: true,
        //滑动速度
        speed: 2000,
        //滑动方向
        direction: "horizontal",
        //小手掌抓取滑动
        grabCursor: true,
        on: {
          //滑动之后回调函数
          slideChangeTransitionStart: function () {
            /* realIndex为滚动到当前的slide索引值 */
            that.imgIndex = this.realIndex - 1;
          },
        },
        //分页器设置
        pagination: ".banner-swiper-pagination",
      },
    };
  },
  created() {
    this.homeData.roadbook.booklist.map((item) => {
      item.window = false;
    });
  },
  //创建前设置
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute("style", "max-width: 100vw;min-width: 100vw;");
  },
  //销毁前清除
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    sendLoginAuthCode() {
      if (this.authCodeCountDown > 0) {
        return;
      }
      if (!this.place) {
        this.toast("请输入目的地！");
        return;
      }
      if (this.phoneNumber) {
        const res = /^1\d{10}$/.test(this.phoneNumber);
        if (!res) {
          this.toast("请正确输入手机号！");
          return;
        }
        this.authCodeCountDown = 60;
        this.authCodeCountDownHandle();
        return get(api.getAuthCode, { phoneNumber: this.phoneNumber })
          .then((res) => {
            this.toast("发送成功！");
          })
          .catch((err) => {
            this.toast("发送验证码失败，请稍后重试");
          });
      } else {
        this.toast("请填写手机号！");
      }
    },
    authCodeCountDownHandle() {
      setTimeout(() => {
        this.authCodeCountDown = this.authCodeCountDown - 1;
        this.authCodeCountDownHandle();
      }, 1000);
    },
    customizeSubmit() {
      if (!this.place) {
        this.toast("请输入目的地！");
        return;
      }
      if (this.phoneNumber) {
        const res = /^1\d{10}$/.test(this.phoneNumber);
        if (!res) {
          this.toast("请重新确认手机号！");
          return;
        }
      } else {
        this.toast("请输入手机号！");
        return;
      }
      if (this.authCodeCountDown == 0) {
        this.toast("请获取验证码！");
        return;
      }
      if (this.authCode) {
        const res = /^[0-9]{6}/.test(this.authCode);
        if (!res) {
          this.toast("请输入正确的验证码！");
          return;
        }
      } else {
        this.toast("请输入验证码！");
        return;
      }
      return post(api.insertClue, {
        phoneNumber: this.phoneNumber,
        authCode: this.authCode,
        place: this.place,
        source: "官网",
      })
        .then((res) => {
          (this.phoneNumber = ""),
            (this.authCode = ""),
            (this.place = ""),
            (this.authCodeCountDown = 0),
            (this.showSuccessModal = true);
        })
        .catch((err) => {
          this.toast("提交失败！");
        });
    },
    toast(content) {
      this.toastContent = content;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000);
    },
    audioPlay(index) {
      this.audioOnPlayIndex = index;
      this.$nextTick(() => {
        const audio = document.querySelector(`#audio${index}`);
        if (audio.paused) {
          audio.play();
          this.isPlay = true;
        } else {
          audio.pause();
          this.isPlay = false;
        }
      });
    },
    goCustomize(url) {
      this.$router.push({ path: url });
    },
    goBottom() {
      setTimeout(() => {
        document
          .getElementById("footer")
          .scrollIntoView({ block: "center", behavior: "smooth" });
      }, 10);
    },
    goPage(url) {
      window.location.href = url;
    },
    goApplet(uuid) {
      window.location.href =
        "https://h5.qishimai.cn/jump.html?uuid=" + uuid + "&s=guanwang";
    },
  },
};
</script>

<style  lang='less' scoped>
.body {
  width: 100vw;
  height: 100%;
  overflow: hidden;
}
.header {
  width: 100%;
  height: 50px;
  position: fixed;
  background: #ffffff;
  box-shadow: 0px 3px 10px rgba(72, 72, 72, 0.16);
  opacity: 1;
  padding: 0 3vw;
  justify-content: space-between;
  z-index: 100;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    font-weight: bold;
    line-height: 45px;
    color: #000000;
    padding-right: 12vw;
  }
}
.banner {
  width: 100vw;
  height: 49vw;
  background: rgba(0, 0, 0, 0);
  border: 1px solid #707070;
  margin-top: 50px;
  opacity: 1;
  .banner-wrap {
    height: 49vw;
  }
}
.box-flex-center {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: PingFang SC;
  padding: 2vw 3vw;
}
.about {
  width: 100%;
  background: #ffffff;
  .button {
    width: 186px;
    height: 28px;
    background: #0ba09a;
    border-radius: 5px;
    margin: 0 10px;
    line-height: 2;
    margin: 10px 0;
  }
}
.book {
  width: 100%;
  background: #f5fbf9;
  .book-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .roadbook-box {
    height: 58vw;
    margin: 10px 0;
    background: #ffffff;
    box-shadow: 0px 3px 16px rgba(92, 92, 92, 0.16);
    border-radius: 6px;
    width: 46vw;
    position: relative;
  }
  .roadbook-image {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
  .roadbook-info {
    bottom: 1vw;
    left: 1vw;
    right: 1vw;
    padding: 1vw;
    background-color: #fff;
    border-radius: 8px;
    position: absolute;
  }
}

.trip {
  width: 100%;
  background-image: url("https://qishimai-1257428522.file.myqcloud.com/website/static/websitephone_bg_roadbook.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .customize-box {
    width: 270px;
    padding: 28px;
    box-shadow: 0px 3px 14px rgba(165, 165, 165, 0.24);
    border-radius: 11px;
    background-color: #fff;
    margin-bottom: 15px;
  }
  .customize-input-wrap {
    height: 36px;
    width: 184px;
    margin: 8px 0 6px 20px;
    padding: 0 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  input {
    height: 36px;
    width: 184px;
  }
  .button {
    width: 186px;
    height: 28px;
    font-size: 11px;
    background: #ffffff;
    color: #0ba09a;
    border-radius: 5px;
    // margin: 0 10px;
    line-height: 2.3;
    margin: 20px 0;
  }
  .customize-button {
    margin-top: 30px;
    width: 272.5px;
    height: 33.5px;
    font-size: 14.5px;
    background: #0ba09a;
    border-radius: 8px;
    color: #ffffff;
  }
}

.team {
  width: 100%;
  .grouptour-city {
    margin: 36px 0 15px 0;
    align-self: flex-start;
  }
  .grouptour-city-item {
    padding: 0 20px 0 0;
  }
  .grouptour-box {
    width: 45vw;
    // margin: 20px 20px 0 0;
    background: #ffffff;
    box-shadow: 0px 3px 40px rgba(93, 93, 93, 0.16);
    border-radius: 6px;
    overflow: hidden;
    margin: 5px 3px;
  }
  .grouptour-box-img {
    width: 100%;
    height: 184px;
  }
}

.evaluate {
  background: #f5fbf9;
  .evaluate-box {
    margin: 10px 0;
    padding: 15px 21px;
    background: #ffffff;
    box-shadow: 0px 3px 16px rgba(128, 128, 128, 0.16);
    opacity: 1;
    border-radius: 8px;
  }
  .evaluate-avatar {
    width: 32.5px;
    height: 32.5px;
    margin-right: 6px;
    border-radius: 50%;
  }
  .evaluate-image {
    height: 87px;
    width: 70px;
    margin: 0 1vw 0 1vw;
    border-radius: 4px;
    box-shadow: 0px 3px 40px rgba(93, 93, 93, 0.16);
  }
}
.story {
  width: 100%;
  background: #ffffff;
  .travelstory-box {
    width: 164px;
    margin: 10px 10px 0 0;
    background: #ffffff;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0px 3px 40px rgba(93, 93, 93, 0.16);
  }
  .travelstory-box-img {
    width: 164px;
    height: 143px;
    object-fit: cover;
  }
  .travelstory-tag {
    padding: 2px 6px;
    margin-right: 6px;
    border: 1px solid #d7d7d7;
    border-radius: 15px;
    font-size: 12px;
    line-height: 14px;
    color: #6c6c6c;
  }
  .travelstory-play {
    padding: 2px 6px;
    border: 1px solid #17a09a;
    border-radius: 15px;
    font-size: 12px;
    line-height: 14px;
    color: #17a09a;
  }
  .pd2 {
    padding: 0 5px 0px;
  }
}
.footer {
  width: 100%;
  background-image: url("https://qishimai-1257428522.file.myqcloud.com/website/static/home_bg2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 0;
  .bgcolor {
    background-color: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    padding: 2vw 0 0 0;
    box-sizing: border-box;
    color: #ffffff;
  }
  .friendlylink-image {
    width: 54px;
    height: 22px;
    margin: 4px 8px;
  }
  .code-image {
    width: 53px;
  }
  .title {
    margin-top: 20px;
    font-size: 18px;
    font-weight: 500;
    line-height: 25px;
    color: #ffffff;
    opacity: 1;
  }
  .subtitle {
    font-size: 6px;
    font-weight: 200;
    line-height: 9px;
    color: #ffffff;
    margin-bottom: 20px;
  }
  .code-wrap {
    margin-top: 5px;
    width: 90px;
  }
  .bgcolor2 {
    background-color: rgba(0, 0, 0, 0.3);
    width: 100%;
    // height: 80px;
    font-size: 13px;
    box-sizing: border-box;
    padding: 10px 0;
    margin-top: 10px;
  }
  .line-hight {
    margin: 3px 0;
  }
}
.title {
  font-size: 18px;
  font-weight: 600;
  line-height: 50px;
  color: #283b5e;
  opacity: 1;
}
.describe {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #666666;
  letter-spacing: 1px;
  text-align: center;
}
.toast {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.online-service {
  position: fixed;
  bottom: 100px;
  right: 0;
  width: 30%;
}
</style>


// WEBPACK FOOTER //
// src/pages/Mobile.vue